  
  /* ── EXPLIZITE RESETS NUR FÜR LANDING-ELEMENTE ── */
  document.querySelectorAll('.bg-landing .hero a[href^="#"]').forEach(function(link) {
  link.addEventListener('click', function(e) {
    var target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});
  
  document.querySelectorAll('.bg-landing .size-row').forEach(row => {
    row.addEventListener('click', function() {
      document.querySelectorAll('.bg-landing .size-row').forEach(r => r.classList.remove('active'));
      this.classList.add('active');
    });
  });

  (function () {
    var slides = document.querySelectorAll('.bg-landing .design-img-slide');
    var dots   = document.querySelectorAll('.bg-landing .design-dot');
    var current = 0;
    function goTo(i) {
      slides[current].classList.remove('active');
      dots[current].classList.remove('active');
      current = (i + slides.length) % slides.length;
      slides[current].classList.add('active');
      dots[current].classList.add('active');
    }
    document.querySelector('.bg-landing .design-slider-next').addEventListener('click', function() { goTo(current + 1); });
    document.querySelector('.bg-landing .design-slider-prev').addEventListener('click', function() { goTo(current - 1); });
    dots.forEach(function(dot, i) { dot.addEventListener('click', function() { goTo(i); }); });
  })();
